import "ol-layerswitcher/src/ol-layerswitcher.css";
import "./LayerSwitcherMixin.scss";

import LayerSwitcher from "ol-layerswitcher/dist/ol-layerswitcher";
import TileArcGISRest from "ol/source/TileArcGISRest";
import TileLayer from "ol/layer/Tile";
import Control from "ol/control/Control";
import TileWMS from "ol/source/TileWMS";
import LayerGroup from "ol/layer/Group";

// eslint-disable-next-line no-unused-vars
class RotateNorthControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement("button");
    button.innerHTML = "L";

    const element = document.createElement("div");
    element.className = "rotate-north ol-unselectable ol-control";
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    // eslint-disable-next-line no-unused-vars
    var layerSelector = null;

    button.addEventListener("click", this.handleRotateNorth.bind(this), true);
    button.addEventListener("mouseover", this.handleMouseOver.bind(this), true);
  }

  addPanel() {
    this.removePanel();
    var layerSelector = document.createElement("div");
    layerSelector.className = "layer-selector";
    layerSelector.style.height = "auto";
    this.getMap()
      .getLayers()
      .forEach((layer) => {
        var checkBoxContainer = document.createElement("div");
        checkBoxContainer.className = "layer-checkbox-container";
        var checkBox = document.createElement("input");
        checkBox.type = "checkbox";
        checkBox.checked = layer.getVisible();
        checkBox.addEventListener("click", () => {
          layer.setVisible(!this.map.getVisible());
        });
        var label = document.createElement("label");
        label.innerText = layer.get("title");
        checkBoxContainer.appendChild(checkBox);
        checkBoxContainer.appendChild(label);
        layerSelector.appendChild(checkBoxContainer);
      });
    this.panel = layerSelector;
    this.panel.addEventListener(
      "mouseout",
      this.handleMouseOut.bind(this),
      false
    );

    this.element.appendChild(this.panel);
  }

  removePanel() {
    if (this.panel) {
      this.element.removeChild(this.panel);
      this.panel = null;
    }
  }

  handleMouseOut() {
    this.removePanel();
  }

  handleMouseOver() {
    this.addPanel();
  }

  handleRotateNorth() {
    this.getMap().getView().setRotation(0);
  }
}

export const LayerSwitcherMixin = async function (map) {
  const baatResponse = await fetch(
    "https://kystinfo.no/WebServices/generic/Baat.ashx"
  );
  const baatJson = await baatResponse.json();
  const baatGkt = baatJson.token;

  var baseUrl =
    "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_WGS84/";
  var mapurl = baseUrl + "GeocacheBasis/MapServer/";
  var graymapurl = baseUrl + "GeocacheGraatone/MapServer/";
  var imageurl = baseUrl + "GeocacheBilder/MapServer/";

  var layers = [
    new LayerGroup({
      title: "Bakgrunnskart",
      layers: [
        new TileLayer({
          title: "Bilde",
          type: "base",
          visible: false,
          source: new TileArcGISRest({
            url: imageurl,
            crossOrigin: "Anonymous",
          }),
        }),
        new TileLayer({
          title: "Grunnkart",
          type: "base",
          visible: false,
          source: new TileArcGISRest({
            url: mapurl,
            params: {
              dpi: 200,
            },
            crossOrigin: "Anonymous",
          }),
        }),
        new TileLayer({
          title: "Sjøkart",
          visible: false,
          type: "base",
          source: new TileWMS({
            urls: [
              "https://gatekeeper1.geonorge.no/BaatGatekeeper/gk/gk.cache?",
              "https://gatekeeper2.geonorge.no/BaatGatekeeper/gk/gk.cache?",
              "https://gatekeeper3.geonorge.no/BaatGatekeeper/gk/gk.cache?",
            ],
            params: {
              LAYERS: "sjokartraster",
              QUERYABLE: false,
              TILED: true,
              TRANSITIONEFFECT: "resize",
              TRANSPARENT: false,
              GKT: baatGkt,
              SRS: "EPSG:3857",
            },
            hidpi: false,
            serverType: "geoserver",
            // Countries have transparency, so do not fade tiles:
            transition: 0,
            crossOrigin: "Anonymous",
          }),
        }),
        new TileLayer({
          title: "Gråtone",
          type: "base",
          visible: true,
          source: new TileArcGISRest({
            url: graymapurl,
            crossOrigin: "Anonymous",
          }),
        }),
        new TileLayer({
          title: "AIS tetthetsplott 250m (2017)",
          visible: false,
          source: new TileWMS({
            urls: [
              "https://wms-geo.kystverket.no/density?version=1.3.0&request=GetCapabilities&service=WMS",
            ],
            params: {
              LAYERS: "AIS-density-Europe",
              QUERYABLE: false,
              TILED: true,
              TRANSITIONEFFECT: "resize",
              TRANSPARENT: true,
              SRS: "EPSG:3857",
            },
            hidpi: false,
            serverType: "geoserver",
            transition: 0,
          }),
        }),
        new TileLayer({
          title: "AIS tetthetsplott 50m (2017)",
          visible: false,
          source: new TileWMS({
            urls: [
              "https://wms-geo.kystverket.no/density?version=1.3.0&request=GetCapabilities&service=WMS",
            ],
            params: {
              LAYERS: "AIS-density-Norway-2016",
              QUERYABLE: false,
              TILED: true,
              TRANSITIONEFFECT: "resize",
              TRANSPARENT: true,
              SRS: "EPSG:3857",
            },
            hidpi: false,
            serverType: "geoserver",
            transition: 0,
          }),
        }),
      ],
    }),
    new LayerGroup({
      title: "Temadata",
      layers: [
        new TileLayer({
          title: "ISPS Havneanlegg",
          visible: false,
          source: new TileWMS({
            urls: [
              "https://services.kystverket.no/wms.ashx?version=1.3.0&service=WMS",
            ],
            params: {
              LAYERS: "layer_420",
              QUERYABLE: false,
              TILED: true,
              TRANSITIONEFFECT: "resize",
              TRANSPARENT: true,
              SRS: "EPSG:3857",
            },
            hidpi: false,
            serverType: "geoserver",
            transition: 0,
            crossOrigin: "Anonymous",
          }),
        }),
        new TileLayer({
          title: "Akvakulturanlegg",
          visible: false,
          source: new TileWMS({
            urls: [
              "https://gis.fiskeridir.no/server/services/fiskeridirWMS_akva/MapServer/WMSServer?",
            ],
            params: {
              LAYERS: "Akvakultur - Lokaliteter",
              QUERYABLE: false,
              TILED: true,
              TRANSITIONEFFECT: "resize",
              TRANSPARENT: true,
              SRS: "EPSG:3857",
            },
            hidpi: true,
            serverType: "mapserver",
            transition: 0,
            crossOrigin: "Anonymous",
          }),
        }),
      ],
    }),
  ];

  map.getLayers().extend(layers);
  var layerSwitcher = new LayerSwitcher();
  map.addControl(layerSwitcher);
  // map.addControl(new RotateNorthControl());

  return map;
};
